import React from 'react'
import { Statistic } from 'semantic-ui-react'
import { connect } from 'react-redux'

const NumPlayers = ({ numPlayers }) => (
    <Statistic label='Online' value={numPlayers} />
)

const mapStateToProps = (state) => ({
    numPlayers: state.onlinePlayers
})

export default connect(
    mapStateToProps
)(NumPlayers)



// WEBPACK FOOTER //
// ./src/components/OnlinePlayers.js